import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { Button } from '@app/shared/ui/button/button';
import { ProgrammeCard } from '@app/shared/ui/programme-card/programme-card';
import { ProgrammeService } from '@app/core/programme/programme.service';
import { ProgrammeCardData, toProgrammeCard } from '@app/core/programme/programme-card';

const CARD_COUNT = 4;

@Component({
  imports: [TranslocoDirective, Button, RouterLink, ProgrammeCard],
  selector: 'app-home-most-loved',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './most-loved.html',
})
export class MostLoved {
  private readonly programmeService = inject(ProgrammeService);

  // Loads the most loved programmes from the API.
  private readonly resource = rxResource({
    stream: () => this.programmeService.getAllProgrammes(),
  });

  protected readonly loading = this.resource.isLoading;
  protected readonly skeletons = Array.from({ length: CARD_COUNT }, (_, i) => i);

  // Computes the list of most loved programmes to display.
  protected readonly programmes = computed<ProgrammeCardData[]>(() => {
    const all = this.resource.hasValue() ? (this.resource.value().data ?? []) : [];
    const featured = all.filter((p) => p.top_pick);
    return (featured.length ? featured : all).slice(0, CARD_COUNT).map(toProgrammeCard);
  });
}
